module.exports = __webpack_public_path__ + "static/media/how_disputes_work.d28d8f16.png";